import React from "react";
import Table from "../Shared/Table";
import Moment from "react-moment";

import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Row,
    Col,
    Button
} from "reactstrap";

import { blockedPhoneNumber } from "core/UrlEndpoints";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { useHistory } from "react-router-dom";

const BlockedPhoneNumberList = () => {
    const history = useHistory();

    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h2 className="title">Blocked Numbers</h2>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h4">Blocked Numbers</CardTitle>
                                <Button
                                    color="primary"
                                    onClick={() => history.push(`blockedphonenumbers/add`)}>
                                    Add
                                </Button>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    url={blockedPhoneNumber}
                                    columns={[
                                        {
                                            header: "Phone Number",
                                            accessorKey: "phoneNumber",
                                        },
                                        {
                                            header: "Blocked From",
                                            accessorKey: "blockedFrom",
                                            accessorFn: row => { return new Date(row.blockedFrom) },
                                            filterFn: 'filterDate',
                                            cell: ({ row }) => (
                                                <>
                                                    {row.original.blockedFrom == null ? (
                                                        ""
                                                    ) : (
                                                        <Moment format="MM/DD/YYYY">{row.original.blockedFrom}</Moment>
                                                    )}
                                                </>
                                            ),
                                        },
                                        {
                                            header: "Blocked Until",
                                            accessorKey: "blockedUntil",
                                            accessorFn: row => { return new Date(row.blockedUntil) },
                                            filterFn: 'filterDate',
                                            cell: ({ row }) => (
                                                <>
                                                    {row.original.blockedUntil == null ? (
                                                        ""
                                                    ) : (
                                                        <Moment format="MM/DD/YYYY">{row.original.blockedUntil}</Moment>
                                                    )}
                                                </>
                                            ),
                                        },
                                        {
                                            header: "Reason",
                                            accessorKey: "reason",
                                        },
                                        {
                                            header: "Blocked By",
                                            accessorKey: "blockedBy",
                                        },
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default BlockedPhoneNumberList;
